import React, { Component } from 'react';
import { isAuthenticated } from '../../utils/auth';
import { history } from '../../index';

class LogoutPage extends Component {
  componentDidMount() {
    if (!isAuthenticated()) {
      history.push('/');
    }

    this.props.onLogout && this.props.onLogout();
  }

  render() {
    return <div className="expand-wrap" />;
  }
}

export default LogoutPage;



// WEBPACK FOOTER //
// ./src/containers/LogoutPage/index.js